import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { useTranslation } from "react-i18next";
import { RenderNavItem } from "../components/RenderNavItem";
import { LightingLeftMenuList } from "../utils/constants";

const Lighting_Home = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {LightingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> {t("Dept.of Lighting")} </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <div id="accordion">
                      <div className="card">
                        <div className="card-header" id="heading1">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse1"
                            aria-expanded="true"
                            aria-controls="collapse1"
                          >
                            {t(
                              "1. What are the key activities of the department?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse1"
                          className="collapse show"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p className="fontSizeClass">
                              {t(
                                "The key activities of the Lighting Department include:"
                              )}
                            </p>
                            <ol type="a" className="kmc-function-list ml-2">
                              {[
                                "Installation and maintenance of street lights under KMC",
                                "Routine and emergency maintenance of street lights",
                                "Installation and maintenance of lights in gardens and parks",
                                "Installation and proper functioning of electric crematoriums",
                                "Installation and maintenance of institutional lighting such as schools, ward offices etc",
                              ].map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ol>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading2">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse2"
                            aria-expanded="true"
                            aria-controls="collapse2"
                          >
                            {t(
                              "2. Who should I contact if streetlights in my area are lit in the day or not lit at night?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse2"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p className="fontSizeClass">
                              {t(
                                "KMC encourages responsible citizens to inform the lighting department in case streetlights are lit during daytime or are not lit in the night. Please refer to Annex A for a list of contacts in case streetlights are not lit as per schedule. You may also contact the Control Room at KMC headquarters at (033) 2286 1212 or (033) 2286 1313 or (033) 2286 1414."
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading3">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse3"
                            aria-expanded="true"
                            aria-controls="collapse3"
                          >
                            {t(
                              "3. My area does not have any streetlights. Whom do I contact for help on the matter?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse3"
                          className="collapse show"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p className="fontSizeClass">
                              {t(
                                "Please refer to Table below for contact details."
                              )}
                            </p>
                            {/* <div className="mayor-table">
                              <table className="table table-bordered">
                                <thead>
                                  <tr className="table-warning table-bor-2">
                                    <th scope="col"> {t("Zone No")} </th>
                                    <th scope="col"> {t("Borough")} </th>
                                    <th scope="col"> {t("Ward")} </th>
                                    <th scope="col">
                                      {t("Authorized Personnel ")}
                                    </th>
                                    <th scope="col"> {t("Address")} </th>
                                    
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td scope="row"> 1 </td>
                                    <td> 1,2,3 </td>
                                    <td> {t("1 to 20, 29 to 35 ")}</td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t("79, Bidhan Sarani,Kolkata 700006")}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 2 </td>
                                    <td> 4,5,6 </td>
                                    <td>
                                      {t("21 to 28, 36 to 55, 60 to 62 ")}
                                    </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "15N, Neli Sengupta Sarani, Kolkata-700087"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 3 </td>
                                    <td> 7,8,9 </td>
                                    <td>
                                      {t("56 to 59, 63 to 80, 82 to 88, 90")}
                                    </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "3rd Floor,28 A.K.N Sen Road.e-Governance Building,Kolkata-700042"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 4 </td>
                                    <td> 10,11,12 </td>
                                    <td> {t("81, 89, 91 to 114")} </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "Santoshpur Municipal Market(1st Floor),Kolkata 700075"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 5 </td>
                                    <td> 13,14,15 </td>
                                    <td> {t("115 to 122 and 127 to 141")} </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "Parnashreepally Government Quarter Block 14,Kolkata 700060"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 6 </td>
                                    <td> 16 </td>
                                    <td> 123,124, 125, 126,142,143,144 </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t("4,DIAMOND PARK,JOKA,KOKATA- 700104")}
                                    </td>
                                    
                                  </tr>
                                </tbody>
                              </table>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading4">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse4"
                            aria-expanded="true"
                            aria-controls="collapse4"
                          >
                            {t(
                              "4. What can I do if I notice pilferage of property/electricity of the lighting department?"
                            )}
                          </button>
                        </div>
                        <div
                          id="collapse4"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p className="fontSizeClass">
                              {t(
                                "The lighting equipment is used to provide civic amenities to the citizens of Kolkata. People who are involved in pilfering lighting equipment are committing a crime against the city. We strongly encourage responsible citizens to inform us in case they notice such activity. Your name and particulars will kept absolutely confidential. You may inform concerned Executive Engineer as per Annex A"
                              )}
                              .
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-header" id="heading4">
                          <button
                            class="btn btn-link fontSizeClass "
                            data-toggle="collapse"
                            data-target="#collapse4"
                            aria-expanded="true"
                            aria-controls="collapse4a"
                          >
                            {t(
                              "5. Who do I contact if streetlight poles are damaged or have loose wires or there is a risk of electrocution?"
                            )}
                          </button>
                        </div>
                        <div id="collapse4a" className="collapse show" data-parent="#accordion">
                          <div className="card-body">
                            <p className="fontSizeClass">
                              {
                                "In case of such events, please contact the lighting department immediately. Please refer to Annex A for contact details."
                              }
                            </p>
                            <div className="mayor-table">
                              <table className="table table-bordered">
                                <thead>
                                  <tr className="table-warning table-bor-2">
                                    <th scope="col"> {t("Zone No ")}</th>
                                    <th scope="col"> {t("Borough")} </th>
                                    <th scope="col"> {t("Ward")} </th>
                                    <th scope="col">
                                      {t("Authorized Personnel")}
                                    </th>
                                    <th scope="col"> {t("Address")} </th>
                                    
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td scope="row"> 1 </td>
                                    <td> 1,2,3 </td>
                                    <td> {t("1 to 20, 29 to 35")} </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t("79, Bidhan Sarani,Kolkata 700006")}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 2 </td>
                                    <td> 4,5,6 </td>
                                    <td>{t("21 to 28, 36 to 55, 60 to 62")}</td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "15N, Neli Sengupta Sarani, Kolkata-700087"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 3 </td>
                                    <td> 7,8,9 </td>
                                    <td>
                                      {t("56 to 59, 63 to 80, 82 to 88, 90")}
                                    </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "3rd Floor,28 A.K.N Sen Road.e-Governance Building,Kolkata-700042"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 4 </td>
                                    <td> 10,11,12 </td>
                                    <td> {t("81, 89, 91 to 114")} </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "Santoshpur Municipal Market(1st Floor),Kolkata 700075"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 5 </td>
                                    <td> 13,14,15 </td>
                                    <td> {t("115 to 122 and 127 to 141")} </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t(
                                        "Parnashreepally Government Quarter Block 14,Kolkata 700060"
                                      )}
                                    </td>
                                    
                                  </tr>
                                  <tr>
                                    <td scope="row"> 6 </td>
                                    <td> 16 </td>
                                    <td> 123,124, 125, 126,142,143,144 </td>
                                    <td>
                                      {t("Executive Engineer (Lighting)")}
                                    </td>
                                    <td>
                                      {t("4,DIAMOND PARK,JOKA,KOKATA- 700104")}
                                    </td>
                                    
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Lighting_Home;
